import { mutatorAction } from 'satcheljs';
import { DateRangeType } from '@fluentui/date-time-utilities/lib/dateValues/dateValues';
import { CalendarSurfaceStore } from 'owa-calendar-surface-dategrid';

export let updateDateRangeTypeInStore = mutatorAction(
    'updateDateRangeTypeInStore',
    (dateRangeType: DateRangeType, store: CalendarSurfaceStore) => {
        store.dateRangeType = dateRangeType;
    }
);
